import { ReactNode } from "react";
import styled from "styled-components";

const Label = styled.label`
  color: #131313;
  font-family: "Noto Sans", sans-serif;
  font-size: 14px;
  font-weight: 600;
  line-height: 140%;
`;

const RequiredMark = styled.span`
  color: #e53935;
  margin-left: 2px;
`;

interface RequiredFieldLabelProps {
  htmlFor?: string;
  children: ReactNode;
}

export default function RequiredFieldLabel({
  htmlFor,
  children,
}: RequiredFieldLabelProps) {
  return (
    <Label htmlFor={htmlFor}>
      {children}
      <RequiredMark>*</RequiredMark>
    </Label>
  );
}
